<template>
  <div ref="LvStateDropdownRadioInputAvatar001" class="lv-state-dropdown-radio-input-avatar">
    <p
      v-if="title"
      class="title"
    >
      {{ $t(title) }}<span v-if="required">*</span>
    </p>
    <label
      v-if="hasCheckBox"
      class="checkbox-item"
    >
      <input
        :value="isCheckBoxSelect"
        type="checkbox"
        @input="$_checkBoxSelect($event)"
      >
      <i class="icon-check-box-outline-blank" />
      <i class="icon-check-box" />
      <p>{{ checkboxText }}</p>
    </label>
    <ValidationProvider
      v-slot="{ errors }"
      class="dropdown-wrap"
      :rules="rules"
    >
      <input
        type="hidden"
        :value="_inputValue"
      >
      <div
        v-click-outside="$_dropdownClose"
        class="dropdown-menu-button-wrap"
      >
        <div
          class="dropdown-menu-button"
          :class="{outline: outline,avatarButton:avatarButton,error:errors.length > 0,disabled:disabled}"
        >
          <i
            v-if="leadingIcon && !_computedButtonAvatar"
            class="icon leading-icon"
            :class="[leadingIcon,{selected: value || !_isCSelectValueEmpty}]"
          />
          <button
            class="input-button"
            @click="$_onclick()"
          >
            <div
              v-if="avatarButton && _computedButtonAvatar"
              class="avatar small"
              :style="{backgroundImage: 'url(' + _computedButtonAvatar + ')' }"
              style="margin-right:6px"
            />
            <p
              v-if="avatarButton && _computedButtonAvatar"
              class="select input-button_title"
            >
              {{ _computedButtonTextLabel }}
            </p>
            <p
              v-else
              class="input-button_title"
              :class="{selected: value || !_isCSelectValueEmpty}"
            >
              {{ _computedButtonTextLabel }}
            </p>
            <i
              v-if="(value || !_isCSelectValueEmpty) && !disabled"
              class="icon-cancel mr-20"
              @click.stop="$_onCancel()"
            />
          </button>
          <div v-if="!avatarButton">
            <i
              v-if="outline"
              class="icon trailing-icon outline icon-chevron-up"
              :class="{show: dropDownMenuShow}"
            />
            <i
              v-else-if="!outline && !dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-down-circle"
            />
            <i
              v-else-if="!outline && dropDownMenuShow"
              class="icon trailing-icon icon-arrow-drop-up-circle"
            />
          </div>
        </div>
        <transition mode="out-in">
          <div
            v-if="dropDownMenuShow"
            class="dropdown-menu"
            :class="{
              priority: priority,
              avatarButton: avatarButton,
              'expand-upward': expandUpward,
              'drop-up': scroll !== undefined ? isDropUp : false,
            }"
          >
            <div class="search-tool">
              <SearchInput
                v-model="searchInputButton.value"
                :placeholder="searchInputButton.placeholder"
                :text-label="searchInputButton.textLabel"
                @enter="$_searchDropdown()"
              />
            </div>
            <perfect-scrollbar
              v-scroll:throttle="{fn: $_onScroll, throttle: 32 }"
              class="ps dropdown-scrollable-content"
            >
              <DotLoading v-if="isLoading.list && !_dropdownItems.length"/>
              <div
                v-for="(item,item_k) in _dropdownItems"
                :key="item_k"
                class="dropdown-menu-item"
                :class="{selected:$_selectedItem(item),textItem:textItem}"
                @click="$_selectMenuItem(item)"
              >
                <div
                  v-if="avatarSelect && isShowAvatar"
                  class="avatar"
                  :style="{backgroundImage:item.avatar ? 'url(' + item.avatar + ')' : 'url(' + require('@/assets/image/avatar.svg') + ')' }"
                />
                <p>{{ $_dropdownItemText(item) }}</p>
              </div>
              <DotLoading v-if="isLoading.list && _dropdownItems.length"/>
            </perfect-scrollbar>
            <div
              v-if="priority"
              class="add-btn"
              @click="$_addFieldOpen()"
            >
              <WsTextButton001
                leading-icon="icon-add-circle"
                primary
                font-size-md
                @click="$_addFieldOpen()"
              >
                {{ addTextLabel }}
              </WsTextButton001>
            </div>
          </div>
        </transition>
        <transition mode="out-in">
          <ValidationObserver
            v-if="isAddActive"
            ref="memberObserver"
            class="dropdown-menu "
            :class="{show: isAddActive, 'drop-up': scroll !== undefined ? isDropUp : false,}"
          >
            <div class="menu-title">
              <i
                class="icon-arrow-left menu-title_icon"
                @click="$_addFieldClose()"
              />
              <p class="menu-title_text">
                {{ addTextLabel }}
              </p>
            </div>
            <div class="dropdown-content">
              <StateInputButton
                v-for="(fieldItem,fieldKey) in addFieldsType"
                :key="fieldKey"
                v-model="addFields[fieldKey]"
                :title="fieldItem.title"
                :placeholder="fieldItem.placeholder"
                required
                :rules="fieldItem.rules"
              />
              <div class="btns">
                <div class="btn">
                  <WsButton001
                    out-line
                    narrow
                    @click="$_addFieldClose()"
                  >
                    {{ $t('取消') }}
                  </WsButton001>
                </div>
                <div class="btn">
                  <WsButton001 @click="$_addSubmitClick()">
                    {{ $t('送出') }}
                  </WsButton001>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </transition>
      </div>
      <div
        v-if="errors.length > 0 && !noErrorText"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ $t(text_e) }}
        </p>
      </div>
      <WsTextChip001
        v-if="remindText"
        gray
        small
        thin
        :leadingIcon="'icon-warning'"
        :textLabel="remindText"
        class="mt-12"
      />
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import H_user from '@/helpers/user';
import H_common from '@/helpers/common';
import H_dropdown from '@/helpers/dropdown';

extend("required", {
  ...required,
  message: "此項目為必填",
});
extend("email", {
  ...email,
  message: "email格式不符",
});

export default {
  name: "LvStateDropdownRadioInputAvatar001",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    customParams: {
      type: Object,
      default() {},
    },
    expandUpward: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    selectValue: {
      type: Object,
      default() {
        return {};
      },
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    avatarButton: {
      type: Boolean,
      default: false,
    },
    addTextLabel: {
      type: String,
      default: "",
    },
    avatarSelect: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
    textItem: {
      type: Boolean,
      default: false,
    },
    noErrorText: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    hasCheckBox: {
      type: Boolean,
      default: false,
    },
    isCheckBoxSelect: {
      type: Boolean,
      default: false,
    },
    checkboxText: {
      type: String,
      default: "",
    },
    resetPlaceholder: {
      type: Boolean,
      default: false,
    },
    customUrl: {
      type: String,
      default: "",
    },
    remindText: {
      type: String,
    },
    scroll: {
      type: Number,
    },
    isShowAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: {
        list: true,
      },
      dropDownMenuShow: false,
      searchInputButton: {
        value: "",
        placeholder: this.$t("搜尋"),
        textLabel: this.$t("搜尋"),
      },
      isAddActive: false,
      addName: "",
      addEmail: "",
      addFields: {},
      addFieldsType: {},
      memberFields: {
        name: "",
        email: "",
      },
      contractorFields: {
        name: "",
        uniform_number: "",
        task_description: "",
      },
      memberFieldsType: {
        name: {
          title: this.$t("人員名稱"),
          placeholder: this.$t("輸入"),
          rules: "required",
        },
        email: {
          title: this.$t("信箱"),
          placeholder: this.$t("請輸入電子信箱"),
          rules: "required|email",
        },
      },
      contractorFieldsType: {
        name: {
          title: this.$t("名稱"),
          placeholder: this.$t("輸入"),
          rules: "required",
        },
        uniform_number: {
          title: this.$t("統一編號"),
          placeholder: this.$t("輸入"),
          rules: "required",
        },
        task_description: {
          title: this.$t("承攬業務"),
          placeholder: this.$t("請輸入承攬業務"),
          rules: "required",
        },
      },
      dropdownMenuItem: [],
      position: { scrollTop: 0, scrollLeft: 0 },
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
      currentPage: 1,
      lastPage: 1,
      C_selectValue: {},
      isStart: false,
      isDropUp: false,
      dropdownHeight: 0,
      dropdownTop: 0,
      windowHeight: 0,
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _computedButtonTextLabel() {
      let placeholder = this.$t(this.placeholder);
      if (this.resetPlaceholder) {
        this.$_restSelectValue();
        return placeholder;
      }
      if (!this.C_selectValue || Object.keys(this.C_selectValue).length === 0)
        return placeholder;
      return this.C_selectValue.name;
    },
    _computedButtonAvatar() {
      if (
        !this.avatarButton ||
        !this.C_selectValue ||
        Object.keys(this.C_selectValue).length === 0
      ) {
        return;
      }
      return this.C_selectValue.avatar;
    },
    _dropdownItems() {
      return this.dropdownMenuItem;
    },
    _isCSelectValueEmpty() {
      const arr = Object.keys(this.C_selectValue);
      return arr.length === 0;
    },
    _inputValue() {
      return this.value
        ? this.value
        : this._isCSelectValueEmpty
        ? null
        : this.C_selectValue;
    }
  },
  watch: {
    selectValue: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (!this.selectValue || Object.keys(this.selectValue).length === 0)
          return;
        this.C_selectValue = newValue;
      },
    },
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropUp();
    },
  },
  created() {
    window.addEventListener("resize", this.$_handleResize);
    window.addEventListener("resize", this.$_getDropdownHeight);
    window.addEventListener("resize", this.$_isDropUp);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_handleResize);
    window.removeEventListener("resize", this.$_getDropdownHeight);
    window.removeEventListener("resize", this.$_isDropUp);
  },
  mounted() {
    this.$_getAddField();
    this.$_getDropdownHeight();
    this.$_isDropUp();
  },
  methods: {
    $_restSelectValue() {
      this.C_selectValue = {};
    },
    $_checkBoxSelect($event) {
      this.$emit("checkbox-select", $event.target.checked);
    },
    $_removeDulcipleElement(list) {
      if (
        !this.C_selectValue ||
        Object.keys(this.C_selectValue).length === 0 ||
        this._dropdownItems.some((item) => item.id !== this.C_selectValue.id)
      ) {
        return list;
      }
      let elementNotInList = list.filter(
        (item) => item.id !== this.C_selectValue.id
      );
      return elementNotInList;
    },
    $_getAddField() {
      if (this.type === "contractor") {
        this.addFields = this.contractorFields;
        this.addFieldsType = this.contractorFieldsType;
      } else {
        this.addFields = this.memberFields;
        this.addFieldsType = this.memberFieldsType;
      }
    },
    $_onScroll(e, position) {
      this.scrollTotalHeight = e.target.scrollHeight;
      this.windowTotalHeight = e.target.offsetHeight;
      this.position = position;
      this.$_scrollBottomGetDropdown();
    },
    $_onclick() {
      if (this.disabled) return;
      this.$_toggleDropdownMenuShow();
    },
    async $_toggleDropdownMenuShow() {
      this.dropDownMenuShow = !this.dropDownMenuShow;
      if (this.dropDownMenuShow) {
        this.dropdownMenuItem = [];
        await this.$_getDropdownMenu('search');
        this.isStart = true;
      } else {
        this.$_dropdownClose();
      }
    },
    $_selectMenuItem(item) {
      this.$emit("input", item.id);
      this.$emit("get-select-item", item);
      this.dropDownMenuShow = false;
      this.C_selectValue = item;
    },
    $_selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    $_selectedItemNum(select, list) {
      if (list.length === 0) return;
      if (!select) {
        return;
      }
      let allId = list.map((item) => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
    $_dropdownClose() {
      this.dropDownMenuShow = false;
      this.isAddActive = false;
      this.currentPage = 1;
      this.searchInputButton.value = "";
      this.dropdownMenuItem = [];
    },
    $_addFieldOpen() {
      this.isAddActive = true;
      this.dropDownMenuShow = false;
    },
    $_addFieldClose() {
      this.isAddActive = false;
      this.$_onclick();
    },
    $_searchDropdown() {
      this.$_getDropdownMenu("search");
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      let getUrl = "";
      if (this.type === "contractor") {
        getUrl = `/factory/${this._currentFactoryId}/contractor`;
      } else if (this.customUrl) {
        getUrl = this.customUrl;
      } else {
        getUrl = `/factory/${this._currentFactoryId}/user`;
      }
      try {
        const res = await this.$axios.post(getUrl, this.addFields);
        let addMember = res.data.data;
        let addElementId = res.data.data.id;
        let dropdownItems = this.type === 'contractor' || this.customUrl ? [res.data.data] : H_user.setDropdownMenuList([res.data.data]);
        this.C_selectValue = addMember;
        this.dropdownMenuItem = dropdownItems.concat(this.dropdownMenuItem);
        this.$emit("input", addElementId);
        this.$_dropdownClose();
        this.$_clearSubmit();
      } catch (err) {
        alert("新增發生錯誤");
      }
    },
    $_clearSubmit() {
      this.addFields = {};
    },
    async $_getDropdownMenu(type) {
      this.isLoading.list = true;
      try {
        if (type === "search") {
          this.currentPage = 1;
        }
        let params = {
          page: this.currentPage,
          search: this.searchInputButton.value,
        };
        params = { ...params, ...this.customParams };
        let getUrl = "";
        if (this.type === "contractor") {
          getUrl = `/factory/${this._currentFactoryId}/contractor`;
        } else if (this.customUrl) {
          getUrl = this.customUrl;
        } else {
          getUrl = `/factory/${this._currentFactoryId}/simplify_factory_index`;
        }
        const res = await this.$axios.get(getUrl, {
          params: params,
        });
        let dropdownItems = this.type === 'contractor' || this.customUrl ? res.data.data : H_user.setDropdownMenuList(res.data.data);
        this.lastPage = res.data.meta.last_page;
        if (type === "search") {
          this.dropdownMenuItem = dropdownItems;
        } else {
          if (
            this.C_selectValue &&
            Object.keys(this.C_selectValue).length > 0 &&
            !this.isStart
          ) {
            this.dropdownMenuItem = [];
            this.dropdownMenuItem.push(this.C_selectValue);
            this.isStart = true;
          }
          dropdownItems = this.$_removeDulcipleElement(dropdownItems);
          this.dropdownMenuItem = this.dropdownMenuItem.concat(dropdownItems);
        }
        this.isLoading.list = false;
      } catch (err) {
        alert("取得列表錯誤");
      }
    },
    $_scrollBottomGetDropdown() {
      const allScrollHeight = this.scrollTotalHeight - this.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      if (scrollHeight / allScrollHeight > 0.95 && !this.isLoading.list) {
        if (this.currentPage < this.lastPage) {
          this.currentPage += 1;
          this.$_getDropdownMenu();
        }
      }
    },
    $_dropdownItemText(item) {
      return H_dropdown.getListOfContractorOrAvatar(this.type, item);
    },
    $_onCancel(){
      this.$emit("input", null);
      this.$emit("get-select-item", {});
      this.C_selectValue =  {};
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      const {height, y} = H_common.getComponentHeightAndY(this.$refs.LvStateDropdownRadioInputAvatar001);
      this.dropdownHeight = height;
      this.dropdownTop = y;
    },
    $_isDropUp() {
      this.isDropUp = H_common.isDropUp(this.dropdownHeight, this.dropdownTop, 300, 300);
    },
  },
};
</script>